import React, {useState} from "react";
import Burger from '../Hamburger.js'
import MobileNavBar from '../MobileNavBar.js'
import '../Desktop.css'

import Jacket from '../../Images/Design/PenguinBooks/ExMarkstheSpot_jacket.jpg'

function ExMarksTheSpot(){
	const [open, setOpen] = useState(false);

	return(
		<div class="page">
		    <div class="designContentPageBook">
		    	<div className="mobileNav">
					<Burger open={open} setOpen={setOpen}/>
					<MobileNavBar open={open} setOpen={setOpen}/>
				</div>
				<img class="contentImage" src={Jacket} />
				<p class="contentTextHMHTitle">Ex Marks The Spot</p>
				<p class="contentTextHMH">Penguin Young Readers</p>
				<p class="contentTextHMH ItalicText" >Art direction, design</p>
				<p class="contentTextHMH2 ItalicText" >Illustration by Jacki Li</p>
		    </div>
		</div>
	)
}

export default ExMarksTheSpot